import React, { useEffect, memo, useState } from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import ResponsiveSwiper from 'Components/new/responsive-swiper'
import Head from 'next/head'
import SwiperButton from 'Components/swiper-button'
import UsedcarCard from 'Components/new/usedcar-card'
import classNames from 'classnames'
import useLazyRender from 'Components/hooks/use-lazy-render'
import { useResponsive } from 'Components/hooks/use-responsive'
import { useCityName } from 'Components/hooks'
import { getAroundCityList, getShSkuTab } from '../../services/home'
import { getCars } from '../../..//used-car/list/components/helper'
import style from './index.module.scss'
import { UPDATE_ANCHOR_STATUS } from '../anchor'
const cityMap = require('../../../used-car/list/components/static/city-map.json')
const ContentList: React.FC<{
  data: any
  prevEl: HTMLElement | null | undefined
  nextEl: HTMLElement | null | undefined
}> = memo(({ data, prevEl, nextEl }) => {
  const cols = {
    sm: 3,
    md: 3,
    lg: 3,
    xl: 3,
    '2xl': 4,
  }

  const rows = {
    sm: 2,
    md: 2,
    lg: 2,
    xl: 2,
    '2xl': 2,
  }

  return (
    <React.Fragment>
      <ResponsiveSwiper
        slideCount={data?.length || 0}
        cols={cols}
        rows={rows}
        gap={12}
        slideClass="tw-w-1/3 2xl:tw-w-1/4"
        navigation={{ prevEl, nextEl }}
      >
        {({ index }) => {
          const carInfo = data[index]

          return (
            <div
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  authentication_method: carInfo?.authentication_method,
                  car_source_type: carInfo?.car_source_type,
                  event_id: 'used_car_source_card',
                  module_id: 'home_page_used_car_module',
                  car_series_id: String(carInfo?.series_id),
                  car_series_name: carInfo?.series_name,
                  car_style_id: carInfo?.car_id,
                  car_style_name: carInfo?.car_name,
                })
              }}
            >
              <UsedcarCard
                src={carInfo?.image || ''}
                isVideo={carInfo?.is_video || false}
                seriesId={carInfo?.series_id || 0}
                sku_id={carInfo?.sku_id || 0}
                title={carInfo?.title || ''}
                sub_title={carInfo?.sub_title || ''}
                cityName={carInfo?.car_source_city_name}
                tips={carInfo?.tags || []}
                price={carInfo?.sh_price || ''}
                office_price={carInfo?.official_price || ''}
                transfer_cnt={carInfo?.transfer_cnt}
              />
            </div>
          )
        }}
      </ResponsiveSwiper>
    </React.Fragment>
  )
})

interface IHeaderProps {
  title: string
  classname?: string
}
const Header: React.FC<IHeaderProps> = ({ title, classname }) => {
  return (
    <>
      <h2
        className={`tw-h-40 tw-w-full tw-flex tw-items-center tw-text-14 tw-font-semibold title ${classname}`}
      >
        {title}
      </h2>
    </>
  )
}

interface IBrandsItem {
  brand_id: number
  brand_logo: string
  brand_name: string
}
interface IHotBrandsProps {
  car_brand_list?: IBrandsItem[]
}
const HotBrands: React.FC<IHotBrandsProps> = ({ car_brand_list = [] }) => {
  const responsive = useResponsive()
  const limit = responsive['xl'] ? 12 : 8
  return (
    <div className="tw-border-color-gray-400  tw-border-b-1 tw-border-solid">
      <div className="tw-pb-12  ">
        <Header title={'热门品牌'} classname="tw-px-16" />
        <div className="tw-grid  tw-grid-cols-4 tw-gap-y-12">
          {car_brand_list.slice(0, limit)?.map((item) => {
            return (
              <a
                key={item?.brand_name}
                target="_blank"
                href={`/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-${item?.brand_id}-x-x-x-x-x-x-x`}
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'hot_used_car_specific_brand',
                    module_id: 'home_page_used_car_module',
                    car_brand_id: item.brand_id,
                    car_brand_name: item.brand_name,
                  })
                }}
                className={`${style.brand}`}
              >
                <div className="tw-flex tw-justify-center ">
                  <img src={item?.brand_logo} className="tw-w-30 tw-h-30 " />
                </div>

                <p className="tw-text-12 xl:tw-text-14 tw-block tw-text-center line-1 ">
                  {item?.brand_name}
                </p>
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}
interface ISeriesItem {
  series_id: number
  series_name: string
  image_url: string
}

interface IHotSeriesProps {
  car_series_list?: ISeriesItem[]
}
const HotSeries: React.FC<IHotSeriesProps> = ({ car_series_list = [] }) => {
  const responsive = useResponsive()
  const index = Object.values(responsive)?.lastIndexOf(true)
  let limit = 12
  switch (index) {
    case 0:
      limit = 12
      break
    case 1:
      limit = 15
      break
    case 2:
      limit = 21
      break
    case 3:
      limit = 18
      break
    case 4:
      limit = 18
      break
    default:
      limit = 12
  }

  return (
    <div className="tw-border-color-gray-400  tw-border-b-1 tw-border-solid">
      <div className="tw-pb-12  tw-px-16">
        <Header title={'热门车系'} />
        <div className="tw-grid  tw-grid-cols-3 tw-gap-y-8 tw-gap-x-12">
          {car_series_list?.slice(0, limit)?.map((item, index) => {
            return (
              <a
                key={item?.series_name}
                target="_blank"
                href={`/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-${item.series_id}-x-x-x-x-x-x`}
                className={classNames({
                  'tw-border-color-gray-500  tw-border-r-1 tw-border-solid ':
                    index !== car_series_list?.length - 1 &&
                    (index + 1) % 3 !== 0,
                })}
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'hot_car_series_specific',
                    module_id: 'home_page_used_car_module',
                    car_series_id: item.series_id,
                    car_series_name: item.series_name,
                  })
                }}
              >
                <p className="tw-text-14 line-1 tw-text-color-gray-800 hover:tw-text-common-orange">
                  {item?.series_name}
                </p>
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}
const Price: React.FC = () => {
  const price_List = [
    { name: '3万以下', str: '0,3' },
    { name: '3-5万', str: '3,5' },
    { name: '5-10万', str: '5,10' },
    { name: '10-15万', str: '10,15' },
    { name: '15-20万', str: '15,20' },
    { name: '20万以上', str: '20,!1' },
  ]
  return (
    <div className="tw-border-color-gray-400  tw-border-b-1 tw-border-solid">
      <div className="tw-pb-12  tw-px-16">
        <Header title={'价格'} />
        <div className="tw-grid  tw-grid-cols-3 tw-gap-y-8 tw-gap-x-12">
          {price_List.map((item, index) => {
            return (
              <a
                key={item?.name}
                target="_blank"
                href={`/usedcar/${item.str}-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`}
                className={classNames({
                  'tw-border-color-gray-500  tw-border-r-1 tw-border-solid ':
                    (index + 1) % 3 !== 0,
                })}
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'price_region_specific_classification',
                    module_id: 'home_page_used_car_module',
                    button_name: item.name,
                  })
                }}
              >
                <p className="tw-text-14 line-1 tw-text-color-gray-800 hover:tw-text-common-orange">
                  {item?.name}
                </p>
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}

interface IFindCarItem {
  tab_name: string
  tab_key: string
}

interface IFindCarProps {
  tab_list?: IFindCarItem[]
}
const FindCar: React.FC<IFindCarProps> = ({ tab_list }) => {
  const findList = [
    {
      name: '视频看车',
      herf: `/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-has_related_video-x-x`,
    },
    {
      name: '4s店专区',
      herf: `/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-car_source_types-x-x`,
    },
    {
      name: '城市代步车',
      herf: `usedcar/0,20-x-x-2-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`,
    },
    {
      name: '准新车',
      herf: `usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-0,3-1,3-x-x-x-x-x-x-x-x-x-x`,
    },
    {
      name: '练手车',
      herf: `/usedcar/0,5-0-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`,
    },
    {
      name: '轿车',
      herf: `/usedcar/x-0-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`,
    },
    {
      name: 'SUV',
      herf: `/usedcar/x-1-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`,
    },
    {
      name: 'MPV',
      herf: `/usedcar/x-2-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`,
    },
  ]
  if (tab_list?.length === 0) {
    findList.splice(1, 1)
  }
  return (
    <div className="tw-pb-12  tw-px-16">
      <Header title={'功能找车'} />
      <div className="tw-grid  tw-grid-cols-2 tw-gap-6">
        {findList.map((item) => {
          return (
            <a
              key={item?.name}
              target="_blank"
              href={item.herf}
              className="tw-bg-color-gray-300 tw-border-color-gray-500  tw-border-1 tw-border-solid tw-rounded-2 tw-h-34 tw-flex tw-items-center tw-justify-center hover:tw-bg-common-yellow hover:tw-bg-opacity-24 hover:tw-border-common-yellow "
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'quick_search_car_specific_option',
                  module_id: 'home_page_used_car_module',
                  button_name: item.name,
                })
              }}
            >
              <p className="tw-text-14 line-1 tw-text-common-black  ">
                {item?.name}
              </p>
            </a>
          )
        })}
      </div>
    </div>
  )
}
const HomeUsedcar: React.FC = () => {
  const [usedCarList, setUsedCarList] = useState<any>([])
  const [shSkuTabData, setShSkuTabData] = useState<any>([])
  const [aroundCityList, setAroundCityList] = useState<any>([])
  const [fontStyleString, setFontStyleString] = useState<string>()
  const [prevEl, setPrevEl] = useState<HTMLElement | null>()
  const [nextEl, setNextEl] = useState<HTMLElement | null>()
  const cityName = useCityName()
  const responsive = useResponsive()
  const fetchData = async (cityName: string) => {
    const [usedCarList, shSkuTabData, aroundCityList] = (
      await Promise.allSettled([
        getCars(
          {
            sh_city_name: cityName,
            page: 1,
          },
          48,
          null
        ),
        getShSkuTab(cityName, null),
        getAroundCityList(cityName, null),
      ])
    ).map((d) => (d.status === 'fulfilled' ? d.value : null))
    // const usedCarList = await getCars(
    //   {
    //     sh_city_name: cityName,
    //     page: 1,
    //   },
    //   48,
    //   null
    // )
    // const shSkuTabData = await getShSkuTab(cityName, null)
    // const aroundCityList = await getAroundCityList(cityName, null)
    setFontStyleString(usedCarList?.fontStyleString)
    setUsedCarList(usedCarList?.search_sh_sku_info_list)
    setShSkuTabData(shSkuTabData)
    setAroundCityList([...new Set(aroundCityList || [])])
    // 切换楼层锚点可见状态
    PubSub.publish(UPDATE_ANCHOR_STATUS, {
      id: 'usedcar',
      name: [cityName, '二手车'].join('·'),
      hidden: (usedCarList?.search_sh_sku_info_list?.length || 0) <= 7,
    })
  }
  useEffect(() => {
    if (cityName) {
      fetchData(cityName)
    }
  }, [cityName])

  const limit = responsive?.['xl'] ? 10 : 6
  const tempCityList = aroundCityList?.slice(0, limit)?.concat(['更多'])
  const cityList = tempCityList?.map((item: string, index: number) => {
    const city = cityMap?.find((city: any) => city.name === item)
    const city_id = city?.code
    return {
      city_name: item,
      href:
        index === tempCityList?.length - 1
          ? `/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`
          : `/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-${city_id}-x-x-x-x-x`,
    }
  })

  return usedCarList?.length > 7 ? (
    <div
      className="home-video-card tw-grid tw-grid-cols-40 tw-gap-x-12 fix-swiper-mutil-row-mt-16 "
      style={{ marginTop: 25 }}
    >
      <Head>
        <style>{fontStyleString}</style>
      </Head>
      <React.Fragment>
        <div
          className="tw-col-span-30 2xl:tw-col-span-32 "
          data-log-view-config={JSON.stringify({
            repeated: true,
          })}
          data-log-view={JSON.stringify({
            event: 'show_event',
            params: {
              event_id: 'home_page_used_car_floor',
              module_id: 'home_page_used_car_module',
            },
          })}
        >
          <div className="tw-flex tw-pr-16 tw-items-center tw-justify-between  tw-h-54">
            <div className="tw-flex line-1">
              <a
                className="tw-text-18 xl:tw-text-20 tw-font-semibold header tw-pl-20 tw-whitespace-nowrap"
                href={`/usedcar/x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x-x`}
                target="_blank"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'used_car_module_title',
                    module_id: 'home_page_used_car_module',
                    button_name: `${cityName}·二手车`,
                  })
                }}
              >
                {cityName}·二手车
              </a>
              <div className="tw-h-28 tw-inline-flex tw-items-center tw-ml-12 ">
                {cityList?.map((item: any, index: number) => {
                  return (
                    <a
                      key={item.city_name}
                      target="_blank"
                      href={item.href}
                      className={`tw-mr-25 ${style.tag}  tw-text-14  tw-text-color-gray-800  hover:tw-text-common-orange tw-relative `}
                      onClick={() => {
                        sendTeaCommEvent('clk_event', {
                          event_id: 'specific_city_option',
                          module_id: 'home_page_used_car_module',
                          button_name: item.city_name,
                        })
                      }}
                    >
                      {item.city_name}
                      {index === cityList?.length - 1 && (
                        <i className="DCD_Icon icon_into_12 tw-text-14" />
                      )}
                    </a>
                  )
                })}
              </div>
            </div>

            <div className="tw-flex ">
              <SwiperButton
                ref={setPrevEl}
                type="prev"
                className="swiper-button-disabled"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'used_car_module_switch_button',
                    module_id: 'home_page_used_car_module',
                    left_right: 'left',
                  })
                }}
              />
              <SwiperButton
                ref={setNextEl}
                type="next"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'used_car_module_switch_button',
                    module_id: 'home_page_used_car_module',
                    left_right: 'right',
                  })
                }}
              />
            </div>
          </div>

          <ContentList
            data={usedCarList?.slice(0, 48) || []}
            prevEl={prevEl}
            nextEl={nextEl}
          />
        </div>
        <div className="tw-col-span-10 2xl:tw-col-span-8 ">
          <h1 className="tw-text-18 xl:tw-text-20 tw-font-semibold   tw-h-54 tw-flex tw-items-center">
            快捷筛选·二手车
          </h1>
          <div className="tw-w-full tw-h-auto  tw-bg-white">
            <HotBrands car_brand_list={shSkuTabData?.car_brand_list} />
            <HotSeries car_series_list={shSkuTabData?.car_series_list} />
            <Price />
            <FindCar tab_list={shSkuTabData?.tab_list || []} />
          </div>
        </div>
        <style jsx>
          {`
            .header {
              background: url(${require('static/position.svg')}) left/18px
                no-repeat;
            }
          `}
        </style>
      </React.Fragment>
    </div>
  ) : null
}

export default HomeUsedcar
